import { when, set, equals } from 'cerebral/operators'
import { state, props, resolveObject } from 'cerebral/tags'
import showDialog from 'modules/App/factories/showDialog'
import isUserAdmin from 'modules/App/actions/isUserAdmin'
import loadDetails from 'modules/Media/actions/loadDetails'
import addToBasket from './addToBasket'
import canHaveTargetMedia from 'utils/canHaveTargetMedia'
import createSnackbar from 'modules/App/factories/createSnackbar'
import hideFileContextMenu from 'modules/Media/chains/hideFileContextMenu'

export default [
  ...hideFileContextMenu,
  when(state`media.showDetail`),
  {
    true: [
      function({ state }) {
        const file = state.get(state.get('media.currentFile'))
        return {
          currentFiles: [file.id]
        }
      }
    ],
    false: [
      when(state`app.currentView`, view => view === 'startpage'),
      {
        true: [
          function({ state, props }) {
            const file = state.get(props.path)
            return {
              currentFiles: [file.id]
            }
          }
        ],
        false: [set(props`currentFiles`, state`media.selectedFiles`)]
      }
    ]
  },
  function({ props, state }) {
    const basketIds = state.get('basket.basketItems')
    const rejectedFiles = []
    Object.keys(basketIds).forEach(key => {
      const item = basketIds[key]
      if (props.currentFiles.indexOf(item.id) !== -1) {
        if (
          !canHaveTargetMedia(item.name) &&
          rejectedFiles.indexOf(item.id) === -1
        ) {
          rejectedFiles.push(item.id)
        }
      }
    })
    const currentFiles = props.currentFiles.filter(file => {
      return rejectedFiles.indexOf(file) === -1
    })

    return { currentFiles, rejectedFiles }
  },
  when(props`rejectedFiles`, rejectedFiles => rejectedFiles.length > 0),
  {
    true: [
      function({ props }) {
        return {
          rejectedCount: props.rejectedFiles.length
        }
      },
      createSnackbar(
        resolveObject({
          key: 'bms.orderBasket.errors.alreadyInBasket',
          params: resolveObject({ count: props`rejectedCount` })
        }),
        'success'
      )
    ],
    false: []
  },
  when(props`currentFiles`, currentFiles => currentFiles.length > 0),
  {
    true: [
      when(props`currentFiles`, currentFiles => currentFiles.length > 1),
      {
        true: [
          function({ state, path, props }) {
            const { currentFiles } = props
            const newCurrentFiles = []
            const filesWithRestriction = currentFiles.reduce((acc, id) => {
              if (!acc.fileIds) {
                acc.count = 0
                acc.fileIds = []
              }
              const file = state.get(`media.files.${id}`)
              if (file.restrictionType) {
                acc.count++
                acc.fileIds.push(id)
              } else {
                newCurrentFiles.push(id)
              }

              return acc
            }, {})
            return filesWithRestriction.fileIds.length > 0
              ? path.showDialog({
                  filesWithRestriction,
                  currentFiles: newCurrentFiles
                })
              : path.addToBasket()
          },
          {
            showDialog: [
              when(
                props`currentFiles`,
                currentFiles => currentFiles.length > 0
              ),
              {
                true: [...addToBasket],
                false: []
              },
              showDialog({
                type: 'alert',
                title: {
                  key: 'bms.media.dialog.restrictions.massAddToBasket.title'
                },
                content: {
                  key: 'bms.media.dialog.restrictions.massAddToBasket.content',
                  params: {
                    count: props`filesWithRestriction.count`
                  }
                },
                confirm: {}
              })
            ],
            addToBasket: [...addToBasket]
          }
        ],
        false: [
          set(props`id`, props`currentFiles.0`),
          set(
            props`restrictionType`,
            state`media.files.${props`id`}.restrictionType`
          ),
          when(props`restrictionType`, type => typeof type === 'string'),
          {
            true: [
              loadDetails, // want's props id
              {
                loaded: [
                  set(props`restriction`, props`payload.restriction`),
                  equals(props`restrictionType`),
                  {
                    CAN_BE_ORDERED: [
                      set(
                        props`title`,
                        'bms.media.dialog.restrictions.restricted.canBeOrdered.title'
                      ),
                      set(props`type`, 'confirm')
                    ],
                    CAN_NOT_BE_ORDERED: [
                      set(props`user`, state`app.user`),
                      set(
                        props`title`,
                        'bms.media.dialog.restrictions.restricted.canNotBeOrdered.title'
                      ),
                      isUserAdmin,
                      {
                        true: [set(props`type`, 'confirm')],
                        false: [set(props`type`, 'alert')]
                      }
                    ],
                    CAN_BE_ORDERED_WITH_ATTEST: [
                      set(
                        props`title`,
                        'bms.media.dialog.restrictions.restricted.withAttest.title'
                      ),
                      set(props`type`, 'confirm')
                    ]
                  },
                  showDialog({
                    type: props`type`,
                    title: {
                      key: props`title`
                    },
                    content: {
                      key: 'bms.media.dialog.restrictions.restricted.content',
                      params: {
                        email: props`restriction.email`,
                        message: props`restriction.message`,
                        file: state`media.files.${props`id`}.name`
                      }
                    },
                    confirm: {
                      signal: 'basket.addToBasket',
                      args: {
                        currentFiles: props`currentFiles`
                      }
                    }
                  })
                ],
                error: [
                  // show snackbar
                ]
              }
            ],
            false: [...addToBasket]
          }
        ]
      }
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Basket/chains/onBeforeAddToBasket.js